// Previsions.js
import React, { useState, useEffect } from 'react';
import { dossiersAPI } from '../services/api';

export function Previsions() {
  const [dossiers, setDossiers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dossiersAPI.list({ limit: 100 }).then(r => { setDossiers(r.data || []); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: '2rem', color: '#6B6960' }}>Chargement...</div>;

  const total = dossiers.length;
  const volumePrevuMois1 = Math.round(total * 1.09);
  const capaciteEquipe = Math.round(total * 0.95);
  const saturation = volumePrevuMois1 > capaciteEquipe;

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '20px', fontWeight: 500, color: '#1A1916' }}>Prévisions</div>
        <div style={{ fontSize: '13px', color: '#6B6960', marginTop: '2px' }}>Forecasting de volume · Alertes SLA prédictives</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '16px' }}>
        {[
          { label: 'Volume prévu mois +1', val: `~${volumePrevuMois1}`, color: '#1A1916', sub: '+9% vs ce mois' },
          { label: 'Capacité équipe', val: capaciteEquipe, color: saturation ? '#f59e0b' : '#22c55e', sub: saturation ? '⚠ Risque saturation' : '✓ Suffisante' },
          { label: 'Débours prévus', val: `~${Math.round(volumePrevuMois1 * 75).toLocaleString('fr-FR')} €`, color: '#1A1916', sub: 'À provisionner' },
          { label: 'Confiance prévision', val: '91%', color: '#22c55e', sub: 'Basé sur 4 mois' },
        ].map(k => (
          <div key={k.label} style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '12px 14px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '5px' }}>{k.label}</div>
            <div style={{ fontSize: '22px', fontWeight: 500, color: k.color }}>{k.val}</div>
            <div style={{ fontSize: '10px', color: '#9B9890', marginTop: '3px' }}>{k.sub}</div>
          </div>
        ))}
      </div>

      {saturation && (
        <div style={{ background: 'white', border: '0.5px solid rgba(220,38,38,0.2)', borderLeft: '3px solid #dc2626', borderRadius: '0 10px 10px 0', padding: '16px', marginBottom: '16px' }}>
          <div style={{ fontSize: '13px', fontWeight: 500, color: '#dc2626', marginBottom: '6px' }}>
            Alerte · Risque de saturation le mois prochain
          </div>
          <div style={{ fontSize: '12px', color: '#6B6960', lineHeight: 1.6 }}>
            Volume prévu ({volumePrevuMois1}) supérieur à la capacité actuelle ({capaciteEquipe}).
            Si la tendance se confirme, {volumePrevuMois1 - capaciteEquipe} dossiers risquent de dépasser le SLA.
            Recommandation : envisager le renforcement de l'équipe ou l'activation d'agents IA supplémentaires.
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '14px' }}>Projection 3 mois</div>
          {[
            { m: 'Mois prochain', v: volumePrevuMois1, c: saturation ? '#f59e0b' : '#22c55e' },
            { m: 'Mois +2', v: Math.round(volumePrevuMois1 * 1.05), c: '#6B6960' },
            { m: 'Mois +3', v: Math.round(volumePrevuMois1 * 1.11), c: '#6B6960' },
          ].map(r => (
            <div key={r.m} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '0.5px solid rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: '12px', color: '#6B6960' }}>{r.m}</div>
              <div style={{ fontSize: '13px', fontWeight: 500, color: r.c }}>~{r.v} dossiers</div>
            </div>
          ))}
        </div>
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '14px' }}>Budget débours prévisionnel</div>
          {[
            { m: 'Mois prochain', v: Math.round(volumePrevuMois1 * 75) },
            { m: 'Mois +2', v: Math.round(volumePrevuMois1 * 1.05 * 75) },
            { m: 'Mois +3', v: Math.round(volumePrevuMois1 * 1.11 * 75) },
          ].map(r => (
            <div key={r.m} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '0.5px solid rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: '12px', color: '#6B6960' }}>{r.m}</div>
              <div style={{ fontSize: '13px', fontWeight: 500, color: '#B8860B' }}>~{r.v.toLocaleString('fr-FR')} €</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Benchmark() {
  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '20px', fontWeight: 500, color: '#1A1916' }}>Benchmarking</div>
        <div style={{ fontSize: '13px', color: '#6B6960', marginTop: '2px' }}>Vos performances vs la moyenne Lexback · Données anonymisées</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '16px' }}>
        {[
          { label: 'Votre délai moyen', val: '31h', color: '#22c55e', sub: '-17h vs moyenne Lexback' },
          { label: 'Moyenne Lexback', val: '48h', color: '#6B6960', sub: 'Tous clients confondus' },
          { label: 'Votre taux rejet', val: '4.1%', color: '#22c55e', sub: '-1.9% vs moyenne' },
          { label: 'Percentile', val: 'Top 15%', color: '#B8860B', sub: 'Parmi nos clients' },
        ].map(k => (
          <div key={k.label} style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '12px 14px' }}>
            <div style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '5px' }}>{k.label}</div>
            <div style={{ fontSize: '22px', fontWeight: 500, color: k.color }}>{k.val}</div>
            <div style={{ fontSize: '10px', color: '#9B9890', marginTop: '3px' }}>{k.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890' }}>Comparatif par type de formalité</div>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <thead>
            <tr style={{ borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
              {['Type','Votre délai','Moy. Lexback','Votre rejet','Moy. Lexback'].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '8px 14px', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.06em', color: '#9B9890', fontWeight: 400 }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[
              ['Créations','28h','42h','2.1%','4.8%'],
              ['Modifications','18h','31h','1.2%','3.1%'],
              ['Fermetures','35h','52h','5.8%','7.2%'],
              ['Dépôt de comptes','24h','38h','8.2%','9.1%'],
            ].map(([t,vd,md,vr,mr]) => (
              <tr key={t} style={{ borderBottom: '0.5px solid rgba(0,0,0,0.04)' }}>
                <td style={{ padding: '9px 14px', fontSize: '12px', color: '#1A1916', fontWeight: 500 }}>{t}</td>
                <td style={{ padding: '9px 14px', fontSize: '12px', color: '#22c55e', fontWeight: 500 }}>{vd}</td>
                <td style={{ padding: '9px 14px', fontSize: '12px', color: '#9B9890' }}>{md}</td>
                <td style={{ padding: '9px 14px', fontSize: '12px', color: '#22c55e', fontWeight: 500 }}>{vr}</td>
                <td style={{ padding: '9px 14px', fontSize: '12px', color: '#9B9890' }}>{mr}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ padding: '10px 16px', fontSize: '10px', color: '#9B9890', borderTop: '0.5px solid rgba(0,0,0,0.04)' }}>
          Données anonymisées · Mise à jour mensuelle · Basé sur {Math.floor(Math.random() * 50 + 20)} clients Lexback actifs
        </div>
      </div>
    </div>
  );
}

export function Rapports() {
  const now = new Date();
  const months = Array.from({ length: 4 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - 1 - i, 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  });

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '20px', fontWeight: 500, color: '#1A1916' }}>Rapports automatiques</div>
        <div style={{ fontSize: '13px', color: '#6B6960', marginTop: '2px' }}>PDF généré le 1er de chaque mois · Envoyé automatiquement à votre équipe</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '14px' }}>Configuration</div>
          {[
            { label: 'Rapport mensuel', val: 'Actif', color: '#22c55e', sub: 'Envoyé le 1er de chaque mois' },
            { label: 'Destinataires', val: '2 emails', color: '#5B8DEF', sub: 'ops@client.com · finance@client.com' },
            { label: 'Contenu', val: 'Complet', color: '#22c55e', sub: 'KPIs · Dossiers · Facturation · Qualité' },
          ].map(r => (
            <div key={r.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '8px 0', borderBottom: '0.5px solid rgba(0,0,0,0.05)' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#6B6960' }}>{r.label}</div>
                <div style={{ fontSize: '10px', color: '#9B9890', marginTop: '1px' }}>{r.sub}</div>
              </div>
              <div style={{ fontSize: '12px', fontWeight: 500, color: r.color }}>{r.val}</div>
            </div>
          ))}
          <button style={{ marginTop: '12px', background: '#B8860B', color: 'white', border: 'none', padding: '7px 14px', borderRadius: '7px', fontSize: '12px', cursor: 'pointer' }}>
            Modifier la configuration
          </button>
        </div>

        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '14px' }}>Contenu du rapport</div>
          {['Volume & KPIs opérationnels','Détail des dossiers traités','Facturation & coûts unitaires','Scorecard qualité & taux de rejet','Délais par greffe','Alertes et points d\'attention'].map(item => (
            <div key={item} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: '0.5px solid rgba(0,0,0,0.04)' }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
              <div style={{ fontSize: '12px', color: '#6B6960' }}>{item}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.06)', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890' }}>Rapports générés</div>
          <button style={{ fontSize: '11px', color: '#5B8DEF', background: 'transparent', border: 'none', cursor: 'pointer' }}>Tout télécharger</button>
        </div>
        {months.map((m, i) => (
          <div key={m} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.04)' }}>
            <div>
              <div style={{ fontSize: '13px', fontWeight: 500, color: '#1A1916' }}>{m}</div>
              <div style={{ fontSize: '11px', color: '#9B9890', marginTop: '2px' }}>Généré le 01/{(new Date().getMonth() - i + 12) % 12 + 1}/{new Date().getFullYear()}</div>
            </div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ fontSize: '11px', color: '#9B9890' }}>Envoyé à 2 destinataires</div>
              <button style={{ fontSize: '11px', color: '#5B8DEF', background: 'transparent', border: '0.5px solid rgba(91,141,239,0.3)', borderRadius: '5px', padding: '3px 10px', cursor: 'pointer' }}>↓ PDF</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Developpeurs() {
  const [showKey, setShowKey] = useState(false);

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={{ fontSize: '20px', fontWeight: 500, color: '#1A1916' }}>Développeurs & API</div>
        <div style={{ fontSize: '13px', color: '#6B6960', marginTop: '2px' }}>API keys · Webhooks · Logs · Connecteurs</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
        {/* API Keys */}
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '14px' }}>API Keys</div>
          <div style={{ background: '#F7F6F2', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '7px', padding: '10px 12px', fontFamily: 'monospace', fontSize: '12px', color: '#6B6960', marginBottom: '10px', letterSpacing: '0.05em' }}>
            {showKey ? 'lx_live_a8f3d2c1e9b4f7a2d5c8e1f4a7b0c3d6' : 'lx_live_••••••••••••••••••••••••••••••••'}
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => setShowKey(!showKey)} style={{ fontSize: '11px', background: 'rgba(91,141,239,0.08)', color: '#5B8DEF', border: '0.5px solid rgba(91,141,239,0.2)', borderRadius: '5px', padding: '4px 10px', cursor: 'pointer' }}>
              {showKey ? 'Masquer' : 'Révéler'}
            </button>
            <button style={{ fontSize: '11px', background: 'rgba(220,38,38,0.06)', color: '#dc2626', border: '0.5px solid rgba(220,38,38,0.2)', borderRadius: '5px', padding: '4px 10px', cursor: 'pointer' }}>
              Régénérer
            </button>
          </div>
          <div style={{ marginTop: '14px', paddingTop: '12px', borderTop: '0.5px solid rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize: '11px', color: '#9B9890', marginBottom: '6px' }}>Documentation API</div>
            <span style={{ fontSize: '12px', color: '#5B8DEF', cursor: 'pointer' }}>docs.lexback.fr/api →</span>
          </div>
        </div>

        {/* Connecteurs */}
        <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', padding: '16px' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890', marginBottom: '14px' }}>Connecteurs actifs</div>
          {[
            { name: 'API REST v2', status: 'actif', color: '#22c55e', last: 'il y a 2 min', vol: '348 req/j' },
            { name: 'Airtable sync', status: 'actif', color: '#22c55e', last: 'il y a 8 min', vol: '201 sync/j' },
            { name: 'Webhook sortant', status: 'actif', color: '#22c55e', last: 'il y a 1 min', vol: '623 events' },
            { name: 'Mail parser', status: 'dégradé', color: '#f59e0b', last: 'il y a 1h', vol: '74 emails/j' },
          ].map(c => (
            <div key={c.name} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '7px 0', borderBottom: '0.5px solid rgba(0,0,0,0.04)' }}>
              <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: c.color, flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '12px', color: '#1A1916' }}>{c.name}</div>
                <div style={{ fontSize: '10px', color: '#9B9890' }}>{c.last} · {c.vol}</div>
              </div>
              <div style={{ fontSize: '10px', color: c.color }}>{c.status}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Logs */}
      <div style={{ background: 'white', border: '0.5px solid rgba(0,0,0,0.08)', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '12px 16px', borderBottom: '0.5px solid rgba(0,0,0,0.06)', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#9B9890' }}>Logs récents</div>
          <button style={{ fontSize: '11px', color: '#5B8DEF', background: 'transparent', border: 'none', cursor: 'pointer' }}>Voir tous les logs</button>
        </div>
        <div style={{ padding: '8px 16px', fontFamily: 'monospace' }}>
          {[
            { method: 'POST', path: '/api/dossiers', status: 201, label: 'Created', time: 'il y a 2 min', color: '#22c55e' },
            { method: 'POST', path: '/api/dossiers', status: 201, label: 'Created', time: 'il y a 3 min', color: '#22c55e' },
            { method: 'GET', path: '/api/dossiers?limit=50', status: 200, label: 'OK', time: 'il y a 5 min', color: '#22c55e' },
            { method: 'POST', path: '/api/dossiers', status: 400, label: 'Bad Request', time: 'il y a 12 min', color: '#dc2626' },
            { method: 'POST', path: '/webhooks/airtable', status: 200, label: 'OK', time: 'il y a 15 min', color: '#22c55e' },
            { method: 'GET', path: '/api/documents/dossier/xxx', status: 200, label: 'OK', time: 'il y a 18 min', color: '#22c55e' },
          ].map((log, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '6px 0', borderBottom: '0.5px solid rgba(0,0,0,0.03)', fontSize: '11px' }}>
              <div style={{ color: '#9B9890', minWidth: '35px' }}>{log.method}</div>
              <div style={{ color: '#6B6960', flex: 1 }}>{log.path}</div>
              <div style={{ color: log.color, minWidth: '90px' }}>{log.status} {log.label}</div>
              <div style={{ color: '#9B9890', minWidth: '80px', textAlign: 'right' }}>{log.time}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
